var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.inventory.message.general") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: {
                      text: _vm.$t("apps.inventory.label.warehousename") + " *"
                    }
                  }),
                  _vm._v(" "),
                  _c("BaseInput", {
                    attrs: {
                      classNames: [{ "is-invalid": _vm.$v.input.name.$error }],
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.name, "$model", $$v)
                      },
                      expression: "$v.input.name.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c(
                    "Label",
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("apps.inventory.label.warehousenameshort")
                          ) +
                          " *\n        "
                      ),
                      _c(
                        "vs-tooltip",
                        {
                          staticStyle: { float: "right", "margin-left": "5px" },
                          attrs: {
                            text: _vm.$t(
                              "apps.inventory.message.runningcodenumber"
                            ),
                            position: "top"
                          }
                        },
                        [_c("i", { staticClass: "fas fa-info-circle" })]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BaseInput", {
                    attrs: {
                      classNames: [
                        "text-uppercase",
                        { "is-invalid": _vm.$v.input.nameShort.$error }
                      ],
                      invalidText:
                        _vm.input.nameShort &&
                        _vm.$v.input.nameShort.isExist === false
                          ? _vm.$t(
                              "apps.inventory.message.warehouseshortnameisalreadyexist"
                            )
                          : null,
                      disabled: _vm.disabled,
                      maxLength: 6
                    },
                    model: {
                      value: _vm.$v.input.nameShort.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.nameShort, "$model", $$v)
                      },
                      expression: "$v.input.nameShort.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.input.nameShort
                ? _c(
                    "Col",
                    { attrs: { className: "col-lg-6" } },
                    [
                      _c("Label", {
                        attrs: { text: _vm.$t("apps.inventory.label.preview") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "preview-short-name" }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "apps.inventory.message.previewwarehousecode",
                                {
                                  name: _vm.nameShortUppercase,
                                  code: _vm.moment().format("YYYY") + "0001"
                                }
                              )
                            )
                          }
                        })
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.inventory.message.location") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.inventory.label.address") }
                  }),
                  _vm._v(" "),
                  _c("BaseTextArea", {
                    attrs: { disabled: _vm.disabled, rows: 3 },
                    model: {
                      value: _vm.input.address,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "address", $$v)
                      },
                      expression: "input.address"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.inventory.message.binlocation") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-12" } },
                [
                  _c(
                    "BaseButton",
                    {
                      attrs: { disabled: _vm.disabled, className: "btn-light" },
                      on: { click: _vm.onClickOpenModal }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("apps.inventory.button.addbinlocation")
                          ) +
                          " (" +
                          _vm._s(_vm.input.binLocations.length) +
                          ")\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.inventory.message.assignskus") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-12" } },
                [
                  !_vm.products.length
                    ? _c("BaseNotFoundData", {
                        attrs: {
                          title: _vm.$t("apps.inventory.message.notfoundskus"),
                          detail: _vm.$t(
                            "apps.inventory.message.createnewproducts"
                          )
                        }
                      })
                    : _c("BaseAssignSkus", {
                        attrs: {
                          items: _vm.assignItems,
                          disabled: _vm.disabled
                        },
                        model: {
                          value: _vm.input.assignSkus,
                          callback: function($$v) {
                            _vm.$set(_vm.input, "assignSkus", $$v)
                          },
                          expression: "input.assignSkus"
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.inventory.message.setting") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("BaseCheckbox", {
                    attrs: {
                      label: _vm.$t(
                        "apps.inventory.message.useprimarywarehouse"
                      ),
                      disabled: _vm.disabled || _vm.disabledCheckBoxPrimary
                    },
                    model: {
                      value: _vm.input.primary,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "primary", $$v)
                      },
                      expression: "input.primary"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showActionButtons
        ? _c("BaseFormAction", {
            attrs: {
              textCancel: _vm.$t("button.cancel"),
              textSubmit: _vm.$t("button.save"),
              isSubmitted: _vm.isSubmitted
            },
            on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("BaseBinLocationModal", {
        attrs: {
          show: _vm.modal.show,
          loading: _vm.modal.loading,
          binLocations: _vm.binLocations
        },
        on: {
          onClose: _vm.handleCloseModal,
          onCancel: _vm.handleCancleModal,
          onSubmit: _vm.handleSumitModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5576fa6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5576fa6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/WmsWarehouseForm.vue
// module id = null
// module chunks = 